import { FormGroup } from '@angular/forms';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import { FormOf } from '@devinco/ui/legacy';
import { WeekdaysFormKeys } from '@pages/reports-page/components/report-tabs/report-information-tab/constants';
import { Driver } from '@pages/reports-page/interfaces';
import { DataFilterCreateEditForm } from '@shared/components/edit-trip-filter-dialog/interfaces';
import { DepartmentDto } from '@shared/interfaces/department';
import DynamicFormUtils from '@shared/utils/dynamic-form.utils';

export default class TripDataFilterFormUtils {
  static setMultiselectDropdownValues(
    drivers: Driver[],
    departments: DepartmentDto[],
    formGroup: FormGroup<FormOf<DataFilterCreateEditForm>>,
    elements: DvDynamicFormElement[]
  ): void {
    const selectedDrivers = drivers.map(user => user.UserID);
    const selectedDepartments = departments.map(
      department => department.DepartmentID
    );

    DynamicFormUtils.setDropdownElementItems(elements, 'Driver', drivers);
    DynamicFormUtils.setDropdownElementItems(
      elements,
      'Department',
      departments
    );

    const formControls = formGroup.controls;
    formControls.Department?.setValue(selectedDepartments);
    formControls.Driver?.setValue(selectedDrivers);
  }

  static constructWeekDayArray(
    formData: DataFilterCreateEditForm
  ): number[] | undefined {
    const selectedValues: number[] = [];
    const weekdayValues = Object.values(WeekdaysFormKeys);
    if (!weekdayValues.some(weekday => !!formData[weekday])) {
      return [];
    }

    weekdayValues.forEach(weekday => {
      if (formData[weekday]) {
        selectedValues.push(Number(weekday));
      }
    });

    return selectedValues.filter(val => val || val === 0);
  }
}
